import { classNames } from '../utilities';

export const BellIcon = ({ className, onClick }) => {
  return (
    <svg
      className={classNames(
        'bell-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.22236 17.2727H9.77793C9.77793 17.7308 9.59063 18.1702 9.25723 18.4941C8.92383 18.818 8.47165 19 8.00015 19C7.52865 19 7.07646 18.818 6.74306 18.4941C6.40966 18.1702 6.22236 17.7308 6.22236 17.2727ZM0.0676589 15.0126C0.000365412 14.8547 -0.0172267 14.681 0.0171086 14.5135C0.0514439 14.3459 0.136164 14.192 0.260549 14.0712L1.77789 12.597V7.77273C1.78075 6.32052 2.32109 4.91776 3.30024 3.82055C4.2794 2.72334 5.63206 2.00489 7.11125 1.79636V0.863636C7.11125 0.634586 7.2049 0.414916 7.3716 0.252953C7.5383 0.09099 7.7644 0 8.00015 0C8.2359 0 8.46199 0.09099 8.62869 0.252953C8.79539 0.414916 8.88904 0.634586 8.88904 0.863636V1.79636C10.3682 2.00489 11.7209 2.72334 12.7 3.82055C13.6792 4.91776 14.2195 6.32052 14.2224 7.77273V12.597L15.7397 14.0712C15.864 14.192 15.9486 14.3459 15.9829 14.5134C16.0172 14.6809 15.9996 14.8545 15.9323 15.0123C15.8651 15.1701 15.7512 15.3049 15.605 15.3998C15.4589 15.4947 15.2871 15.5454 15.1113 15.5455H0.888997C0.713204 15.5455 0.541345 15.4949 0.39515 15.4C0.248954 15.3052 0.134988 15.1704 0.0676589 15.0126ZM3.03479 13.8182H12.9655L12.7051 13.5651C12.5383 13.4032 12.4447 13.1836 12.4446 12.9545V7.77273C12.4446 6.62747 11.9764 5.52913 11.1429 4.71931C10.3094 3.9095 9.17889 3.45455 8.00015 3.45455C6.8214 3.45455 5.69093 3.9095 4.85743 4.71931C4.02393 5.52913 3.55568 6.62747 3.55568 7.77273V12.9545C3.55563 13.1836 3.46194 13.4032 3.29523 13.5651L3.03479 13.8182Z"
        fill="#059669"
      />
    </svg>
  );
};
